<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="navaid.navaidId > 0; else addTitle">Edit Navaid</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Navaid Information</legend>
        <p>
          <mat-form-field class="edit-navaid">
            <input matInput
                   placeholder="Navaid Name *"
                   formControlName="name"
                   [(ngModel)]="navaid.name">
          </mat-form-field>
          <mat-form-field class="edit-navaid">
            <input matInput
                   placeholder="Navaid Identifier *"
                   formControlName="identifier"
                   [(ngModel)]="navaid.identifier">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-navaid">
            <mat-select placeholder="Navaid Type *" [(value)]="selectedNavaidType" name="type" formControlName="type">
              <mat-option value="MarineNDB">Marine NDB</mat-option>
              <mat-option value="VOR_DME">VOR/DME</mat-option>
              <mat-option value="TACAN">TACAN</mat-option>
              <mat-option value="VOT">VOT</mat-option>
              <mat-option value="NDB">NDB</mat-option>
              <mat-option value="NDB_DME">NDB/DME</mat-option>
              <mat-option value="VORTAC">VORTAC</mat-option>
              <mat-option value="VOR">VOR</mat-option>
              <mat-option value="DME">DME</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-navaid">
            <input matInput
                   placeholder="Navaid Frequency *"
                   formControlName="frequency"
                   [(ngModel)]="navaid.frequency">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-navaid">
            <input matInput
                   placeholder="Navaid Latitude (Decimal) *"
                   formControlName="latitude"
                   [(ngModel)]="latitude">
          </mat-form-field>
          <mat-form-field class="edit-navaid">
            <input matInput
                   placeholder="Navaid Longitude (Decimal) *"
                   formControlName="longitude"
                   [(ngModel)]="longitude">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Navaid
</ng-template>
